import React from 'react';

const ProgressBar = ({ value, max, color }) => {
  const percentage = Math.min(100, Math.max(0, (value / max) * 100));
  return (
    <div className="progress" style={{ height: "5px", borderRadius: "5px", backgroundColor: "#f0f0f0" }}>
      <div 
        className="progress-bar" 
        role="progressbar" 
        style={{ 
          width: `${percentage}%`, 
          backgroundColor: color,
          borderRadius: "5px",
          transition: "width 0.5s ease-in-out"
        }} 
        aria-valuenow={percentage} 
        aria-valuemin="0" 
        aria-valuemax="100"
      ></div>
    </div>
  );
};

export default ProgressBar;